var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a, _b, _c;
export var mobile = function (breakpoint) { return "only screen and (max-width: ".concat(breakpoint - 1, "px)"); };
export var reset = {
    alignItems: 'flex-start',
    borderCollapse: 'separate',
    borderSpacing: 0,
    color: 'black',
    display: 'block',
    fontFamily: '"Open Sans", Arial, sans-serif',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    justifyContent: 'flex-start',
    letterSpacing: 'normal',
    lineHeight: 'normal',
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    textAlign: 'left',
    textIndent: 0,
    textTransform: 'none',
    textShadow: 'none',
    verticalAlign: 'baseline',
    wordSpacing: 'normal',
};
var icon = {
    expandBold: "data:image/svg+xml,%3Csvg baseProfile='tiny' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='XXXXX' d='M8 13.615l-8-8 1.346-1.346L8 10.924l6.654-6.655L16 5.615z'/%3E%3C/svg%3E",
};
var clearFix = function () { return ({
    ':before': {
        content: '" "',
        display: 'table',
    },
    ':after': {
        content: '" "',
        display: 'table',
        clear: 'both',
    },
}); };
var getIcon = function (icon, size, fill, label) {
    if (label === void 0) { label = ''; }
    var fillEncoded = fill.replace('#', '%23');
    var dataUri = icon.replace('XXXXX', fillEncoded);
    return {
        label: label,
        display: 'inline-block',
        backgroundSize: 'contain',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundImage: "url(\"".concat(dataUri, "\")"),
        width: size,
        height: size,
    };
};
var getTransition = function () {
    var additionalProperties = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        additionalProperties[_i] = arguments[_i];
    }
    return ({
        transitionDuration: '300ms',
        transitionProperty: __spreadArray(['background', 'border', 'color', 'font-size', 'font-weight'], additionalProperties, true).join(', '),
        transitionTimingFunction: 'eas-out',
    });
};
// Primary
export var active = {
    background: 'linear-gradient(71deg, #BA191C 4.69%, #ED2024 53.65%, #FD3F20 78.13%, #FF8F1C 100%)',
    boxShadow: 'inset 0px 0px 4px 0.5px rgba(50, 62, 72, 0.08)',
    ':focus': {
        outline: 'none',
    },
};
export var disabled = {
    background: '#DFE4E8',
    border: 'none',
    boxShadow: 'none',
    color: '#8E9AA3',
    cursor: 'not-allowed',
    filter: 'none',
    '[class*="-badge"]': {
        color: '#8E9AA3',
        backgroundColor: '#DFE4E8',
    },
    '[class*="pcty-icon"]': {
        color: '#8E9AA3',
    },
    '[class*="-dropdown"]': __assign({}, getIcon(icon.expandBold, 16, '#8E9AA3')),
};
export var focus = {
    background: 'linear-gradient(71deg, #ED2024 60.42%, #FD3F20 83.85%, #FF8F1C 100%)',
    boxShadow: '0px 2px 4px 0.5px rgba(50, 62, 72, 0.08)',
    outline: "2px solid #2D6BE0",
    outlineOffset: '1px',
};
export var hover = {
    boxShadow: '0px 2px 4px 0.5px rgba(50, 62, 72, 0.08)',
    background: 'linear-gradient(71deg, #ED2024 60.42%, #FD3F20 83.85%, #FF8F1C 100%)',
};
var badgeDefaults = __assign({ color: '#000000', backgroundColor: '#ffffff', borderRadius: "".concat(16, "px"), fontWeight: 625, overflow: 'hidden', boxSizing: 'border-box', fontSize: 12, height: 24, minWidth: 24, padding: "6px ".concat(8, "px"), marginRight: 8, lineHeight: '12px' }, getTransition());
export var smallBadgeButton = {
    paddingInline: "".concat(4, "px ").concat(8, "px"),
};
export var smallBadgeSecondaryButton = {
    paddingBlock: '3px', // Needs to be 3 instead of 4 to offset the border that other buttons don't have
};
export var mediumBadgeButton = {
    paddingInline: "".concat(4, "px ").concat(16, "px"),
};
export var largeBadgeButton = {
    paddingInline: "".concat(8, "px ").concat(16, "px"),
};
export var badge = __assign({ label: 'badge' }, badgeDefaults);
export var smallBadge = {
    fontSize: "".concat(12, "px !important"),
    padding: "".concat(2, "px ").concat(4, "px !important"),
    height: 'unset !important',
    marginRight: "".concat(4, "px !important"),
};
export var dropdownIcon = getIcon(icon.expandBold, 16, '#ffffff', 'dropdown');
export var button = __assign(__assign(__assign(__assign({}, reset), { background: 'linear-gradient(71.06deg, #FC2621 0%, #FD3F20 49.75%, #FF841A 100%)', color: '#ffffff', appearance: 'none', border: 'none', boxSizing: 'border-box', borderRadius: 999, cursor: 'pointer', display: 'inline-block', fontSize: 16, fontWeight: '625', minHeight: 40, lineHeight: '24' + 'px', minWidth: 40, overflow: 'visible', padding: "".concat(4, "px ").concat(8, "px"), position: 'relative', textAlign: 'center', textDecoration: 'none', verticalAlign: 'top', zoom: 1, boxShadow: '0px 1px 2px 0px rgba(50, 62, 72, 0.08)' }), getTransition()), { '::selection': {
        background: 'transparent',
    }, '[class*="-badge"]': __assign({}, badgeDefaults), '[class*="-dropdown"]': __assign({}, getIcon(icon.expandBold, 16, '#ffffff')), '[class*="pcty-icon"]': {
        color: '#ffffff',
    }, ':hover': hover, ':focus': focus, ':focus-visible': focus, ':active': active, ':disabled': disabled });
// Secondary
export var activeSecondary = {
    background: 'linear-gradient(0deg, #F5F8FA 0%, #F5F8FA 100%), #FFF',
    boxShadow: 'inset 0px 0px 4px 0.5px rgba(50, 62, 72, 0.08)',
    ':focus': {
        outline: 'none',
    },
};
export var selectedSecondary = {
    backgroundColor: '#1454CC',
    color: '#ffffff',
    ':hover': {
        backgroundColor: '#003FB8',
        color: '#003FB8',
    },
    ':hover:active': {
        backgroundColor: '#2B66D6',
        color: '#003FB8',
    },
    ':focus': {
        backgroundColor: '#1454CC',
        color: '#003FB8',
    },
    ':focus-visible': {
        backgroundColor: '#1454CC',
        color: '#003FB8',
    },
};
export var hoverSecondary = {
    background: 'linear-gradient(0deg, #E5EFFF 0%, #E5EFFF 100%), #FFF',
    boxShadow: '0px 2px 4px 0.5px rgba(50, 62, 72, 0.08)',
};
export var badgeSecondary = __assign(__assign(__assign({}, badgeDefaults), badge), { backgroundColor: '#1454CC', color: '#ffffff' });
export var dropdownIconSecondary = getIcon(icon.expandBold, 16, '#1454CC', 'dropdown');
export var secondaryFocus = __assign(__assign({}, focus), { background: 'linear-gradient(0deg, #E5EFFF 0%, #E5EFFF 100%), #FFF', boxShadow: '0px 2px 4px 0.5px rgba(50, 62, 72, 0.08)' });
export var disabledSecondary = __assign(__assign({}, disabled), { background: "transparent", color: '#8E9AA3', border: "1px solid ".concat('#A8B2BA'), '[class*="-badge"]': {
        color: '#8E9AA3',
        background: '#DFE4E8',
    } });
export var secondary = __assign(__assign(__assign(__assign({}, button), { background: 'transparent', border: "1px solid #2D6BE0", color: '#003FB8', boxShadow: '0px 1px 2px 0px rgba(50, 62, 72, 0.08)' }), getTransition()), { ':hover': hoverSecondary, ':focus': secondaryFocus, ':focus-visible': secondaryFocus, ':active': activeSecondary, ':disabled': disabledSecondary, '[class*="-badge"]': badgeSecondary, '[class*="pcty-icon"]': {
        color: '#1454CC',
    }, '[class*="-dropdown"]': __assign({}, getIcon(icon.expandBold, 16, '#ffffff')) });
// Default
export var activeDefault = {
    background: '#003FB8',
    boxShadow: 'inset 0px 0px 4px 0.5px rgba(50, 62, 72, 0.08)',
    ':focus': {
        outline: 'none',
    },
};
export var hoverDefault = {
    backgroundColor: '#2B66D6',
    boxShadow: '0px 2px 4px 0.5px rgba(50, 62, 72, 0.08)',
};
export var badgeDefault = __assign(__assign(__assign({}, badgeDefaults), badge), { color: '#1454CC' });
export var defaultFocus = __assign(__assign({}, focus), { background: '#2B66D6', boxShadow: '0px 2px 4px 0.5px rgba(50, 62, 72, 0.08)' });
export var disabledDefault = __assign({}, disabled);
export var defaultButton = __assign(__assign(__assign(__assign({}, button), { background: '#1454CC', color: '#ffffff' }), getTransition()), { ':hover': hoverDefault, ':focus': defaultFocus, ':focus-visible': defaultFocus, ':active': activeDefault, ':disabled': disabledDefault, '[class*="-dropdown"]': __assign({}, getIcon(icon.expandBold, 16, '#ffffff')), '[class*="pcty-icon"]': {
        color: '#ffffff',
    }, '[class*="-badge"]': badgeDefault });
// Borderless
export var activeBorderless = {
    background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.02) 0%, rgba(0, 0, 0, 0.02) 100%), #F2F7FF',
    ':focus': {
        outline: 'none',
    },
    boxShadow: 'none',
};
export var disabledBorderless = __assign(__assign({}, disabled), { background: 'transparent', color: '#8E9AA3' });
export var hoverBorderless = {
    background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.32) 0%, rgba(255, 255, 255, 0.32) 100%), #F2F7FF',
    boxShadow: 'none',
};
export var badgeBorderless = __assign(__assign(__assign({}, badgeDefaults), badge), { color: '#ffffff', backgroundColor: '#1454CC' });
export var processingBorderless = {
    color: 'transparent',
    ':hover': {
        boxShadow: 'none',
    },
    i: {
        color: 'transparent !important',
    },
};
export var borderlessFocus = __assign(__assign({}, focus), { background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.32) 0%, rgba(255, 255, 255, 0.32) 100%), #F2F7FF', boxShadow: 'none' });
export var borderless = __assign(__assign(__assign(__assign({}, button), { background: 'transparent', borderColor: 'transparent', boxShadow: 'none', color: '#003FB8', filter: 'none', marginLeft: '4px', padding: "".concat(4, "px ").concat(8, "px") }), getTransition('box-shadow')), { '& + button, & + a': {
        marginLeft: '4px !important',
    }, ':hover': hoverBorderless, ':focus': borderlessFocus, ':focus-visible': borderlessFocus, ':active': activeBorderless, ':disabled': disabledBorderless, '[class*="-badge"]': badgeBorderless, '[class*="pcty-icon"]': {
        color: '#1454CC',
    } });
// Icon
var iconContainer = {
    display: 'flex',
    alignItems: 'center',
};
export var iconContainerSmall = __assign(__assign({}, iconContainer), { paddingRight: 6 });
export var iconContainerMedium = __assign(__assign({}, iconContainer), { paddingRight: 8 });
export var iconContainerLarge = __assign(__assign({}, iconContainer), { paddingRight: 10 });
export var iconContainerRight = {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 8,
};
export var iconOnly = {
    small: {
        justifyContent: 'center',
        paddingLeft: 0,
        paddingRight: 0,
        width: 24,
    },
    medium: {
        justifyContent: 'center',
        paddingLeft: 0,
        paddingRight: 0,
        width: 32,
    },
    large: {
        justifyContent: 'center',
        paddingLeft: 0,
        paddingRight: 0,
        width: 40,
    },
};
export var iconOnlyBordered = {
    paddingLeft: 0,
    paddingRight: 0,
};
export var iconOnlyBorderless = {
    '[class*="pcty-icon"]': {
        color: '#000000',
    },
};
export var splitButtonLeft = __assign(__assign({}, button), { background: '#FC2621', borderRadius: "".concat(999, "px 0 0 ").concat(999, "px"), transition: 'unset', ':disabled': __assign(__assign({}, button[':disabled']), { borderLeft: 'none', marginLeft: -1 }), ':focus': __assign(__assign({}, focus), { zIndex: 1 }) });
export var splitButtonRight = __assign(__assign({}, button), { background: 'linear-gradient(71.06deg, #FC2621 0%, #FD3F20 30%, #FF841A 100%)', borderRadius: "0 ".concat(999, "px ").concat(999, "px 0"), filter: 'none', paddingLeft: "".concat(8, "px"), paddingRight: "".concat(8, "px"), marginLeft: 1, ':disabled': __assign(__assign({}, button[':disabled']), { borderLeft: "1px solid ".concat('#ffffff'), marginLeft: -1 }) });
export var splitButtonLeftSecondary = __assign(__assign({}, secondary), { borderRadius: "".concat(999, "px 0 0 ").concat(999, "px") });
export var splitButtonRightSecondary = __assign(__assign({}, secondary), { borderRadius: "0 ".concat(999, "px ").concat(999, "px 0"), height: '14px', marginLeft: -1, ':disabled': __assign(__assign({}, secondary[':disabled']), { borderLeft: 'none', marginLeft: -1 }), '[class*="-dropdown"]': __assign({}, getIcon(icon.expandBold, 16, '#1454CC', 'dropdown')) });
export var splitButtonLeftDefault = __assign(__assign({}, defaultButton), { borderRadius: "".concat(999, "px 0 0 ").concat(999, "px") });
export var splitButtonRightDefault = __assign(__assign({}, defaultButton), { borderRadius: "0 ".concat(999, "px ").concat(999, "px 0"), paddingLeft: "".concat(8, "px"), paddingRight: "".concat(8, "px"), marginLeft: 1, ':disabled': __assign(__assign({}, defaultButton[':disabled']), { borderLeft: "1px solid ".concat('#ffffff'), marginLeft: -1 }) });
// Notification
export var notification = __assign(__assign({}, button), { border: '1px solid #cccccc', borderColor: '#ffffff', background: 'transparent', color: '#ffffff', boxShadow: 'none', '--button-hover-text-color': '#000000', ':focus': __assign(__assign({}, focus), { background: 'transparent', '--box-shadow-color': '#ffffff', outlineColor: '#1E2C38' }), ':focus-visible': __assign(__assign({}, focus), { background: 'transparent', '--box-shadow-color': '#ffffff' }), ':hover': {
        backgroundColor: '#ffffff',
        borderColor: 'transparent',
        color: 'var(--button-hover-text-color)',
    }, ':active': {
        backgroundColor: "".concat('#000000', "50"),
        borderColor: 'transparent',
        color: '#ffffff',
    } });
export var notificationBlack = __assign(__assign({}, notification), { borderColor: '#393939', backgroundColor: 'transparent', color: '#000000', ':focus': __assign(__assign({}, focus), { background: 'transparent', '--box-shadow-color': '#000000' }), ':focus-visible': __assign(__assign({}, focus), { background: 'transparent', '--box-shadow-color': '#000000' }), ':hover': {
        backgroundColor: "".concat('#000000', "30"),
        borderColor: 'transparent',
        color: '#000000',
    }, ':active': {
        backgroundColor: "".concat('#000000', "50"),
        borderColor: 'transparent',
        color: '#000000',
    } });
export var notificationBlue = __assign(__assign({}, notification), { borderColor: '#002E85', backgroundColor: 'transparent', color: '#002E85', ':focus': __assign(__assign({}, focus), { background: 'transparent', '--box-shadow-color': '#000000' }), ':focus-visible': __assign(__assign({}, focus), { background: 'transparent', '--box-shadow-color': '#000000' }), ':hover': {
        backgroundColor: "".concat('#003499'),
        borderColor: 'transparent',
        color: '#ffffff',
    }, ':active': {
        backgroundColor: "".concat('#1454CC'),
        borderColor: 'transparent',
        color: '#ffffff',
    } });
export var notificationRed = __assign(__assign({}, notification), { borderColor: '#ab2811', backgroundColor: 'transparent', color: '#ab2811', ':focus': __assign(__assign({}, focus), { background: 'transparent', '--box-shadow-color': '#000000' }), ':focus-visible': __assign(__assign({}, focus), { background: 'transparent', '--box-shadow-color': '#000000' }), ':hover': {
        backgroundColor: "#ab2811",
        borderColor: 'transparent',
        color: '#ffffff',
    }, ':active': {
        backgroundColor: "#ff8800",
        borderColor: 'transparent',
        color: '#ffffff',
    } });
export var notificationBorderless = __assign(__assign({}, borderless), { color: '#ffffff', ':disabled': __assign(__assign({}, disabled), { background: 'transparent', borderColor: 'transparent', ':hover': {
            borderColor: 'transparent',
        } }), ':focus': __assign(__assign({}, focus), { background: 'transparent', '--box-shadow-color': '#ffffff' }), ':focus-visible': __assign(__assign({}, focus), { background: 'transparent', '--box-shadow-color': '#ffffff' }), ':hover': {
        backgroundColor: "".concat('#000000', "25"),
        borderColor: 'transparent',
        color: '#ffffff',
    }, ':active': {
        backgroundColor: "".concat('#000000', "40"),
        borderColor: 'transparent',
    } });
export var notificationBorderlessBlack = __assign(__assign({}, notificationBorderless), { backgroundColor: 'transparent', color: '#393939', ':focus': __assign(__assign({}, focus), { background: 'transparent', '--box-shadow-color': '#000000' }), ':focus-visible': __assign(__assign({}, focus), { background: 'transparent', '--box-shadow-color': '#000000' }), ':hover': {
        backgroundColor: "".concat('#000000', "15"),
        borderColor: 'transparent',
    }, ':active': {
        backgroundColor: "".concat('#000000', "25"),
        borderColor: 'transparent',
    } });
export var notificationBorderlessBlue = __assign(__assign({}, notificationBorderless), { backgroundColor: 'transparent', color: '#002E85', ':focus': __assign(__assign({}, focus), { background: 'transparent', '--box-shadow-color': '#000000' }), ':focus-visible': __assign(__assign({}, focus), { background: 'transparent', '--box-shadow-color': '#000000' }), ':hover': {
        backgroundColor: "".concat('#002E85', "15"),
        borderColor: 'transparent',
    }, ':active': {
        backgroundColor: "".concat('#002E85', "25"),
        borderColor: 'transparent',
    } });
export var notificationBorderlessRed = __assign(__assign({}, notificationBorderless), { backgroundColor: 'transparent', color: '#ab2811', ':focus': __assign(__assign({}, focus), { background: 'transparent', '--box-shadow-color': '#000000' }), ':focus-visible': __assign(__assign({}, focus), { background: 'transparent', '--box-shadow-color': '#000000' }), ':hover': {
        backgroundColor: "#ab281115",
        borderColor: 'transparent',
    }, ':active': {
        backgroundColor: "#ab281125",
        borderColor: 'transparent',
    } });
// Loader - Primary
export var loader = {
    background: 'linear-gradient(71.06deg, #FC2621 0%, #FD3F20 49.75%, #FF841A 100%)',
    border: 'none',
    borderRadius: 999,
    bottom: 0,
    color: '#ffffff',
    display: 'table-cell',
    height: '100%',
    left: 0,
    lineHeight: 0,
    marginLeft: 0,
    marginTop: 0,
    overflow: 'hidden',
    position: 'absolute',
    right: 0,
    top: 0,
    width: '100%',
    zIndex: 799,
};
export var loadingAnimation = {
    display: 'block',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: 'auto',
    margin: 'auto',
    padding: 0,
    height: 8,
    '@keyframes bouncedelay': {
        '0%': {
            transform: 'scale(0)',
        },
        '80%': {
            transform: 'scale(0)',
        },
        '100%': {
            transform: 'scale(0)',
        },
        '40%': {
            transform: 'scale(1)',
        },
    },
};
export var loaderDot = {
    verticalAlign: 'middle',
    width: 8,
    height: 8,
    backgroundColor: '#ffffff',
    borderRadius: '100%',
    display: 'inline-block',
    animation: "bouncedelay ".concat(parseFloat('300ms'.replace('ms', '')) * 4, "ms infinite ease-in-out"),
    /* Prevent first frame from flickering when animation starts */
    animationFillMode: 'both',
};
export var loaderDot1 = {
    animationDelay: "-300ms",
};
export var loaderDot2 = {
    animationDelay: "-".concat(parseFloat('300ms'.replace('ms', '')) / 2, "ms"),
};
// Loader - Secondary
export var loaderSecondary = __assign(__assign({}, loader), { border: 'none', background: '#ffffff' });
export var loaderDotSecondary = __assign(__assign({}, loaderDot), { backgroundColor: '#1454CC' });
// Loader - Secondary
export var loaderDefault = __assign(__assign({}, loader), { border: 'none', background: '#1454CC' });
export var loaderDotDefault = __assign({}, loaderDot);
// Loader - Borderless
export var loaderBorderless = __assign(__assign({}, loader), { background: 'transparent' });
export var loaderDotBorderless = __assign(__assign({}, loaderDot), { backgroundColor: '#1454CC' });
// Misc
export var buttonContainer = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};
export var fullWidth = __assign({ textAlign: 'center', margin: 0, width: '100%' }, clearFix());
export var flexed = {
    flexGrow: 1,
};
export var responsive = (_a = {},
    _a["@media ".concat(mobile(700))] = {
        textAlign: 'center',
        margin: 0,
        width: '100%',
        fontSize: '18px',
        lineHeight: "24px",
        padding: "".concat(8 - 1, "px ").concat(24),
    },
    _a);
export var buttonSpacing = {
    marginLeft: 16,
};
export var buttonSpacingReset = {
    marginLeft: 0,
};
export var splitButtonWrapper = {
    display: 'inline-block',
};
// Sizes
export var small = {
    fontSize: "".concat(12, "px"),
    fontWeight: '625',
    minHeight: 24,
    minWidth: 24,
    padding: "".concat(4, "px ").concat(8, "px"),
    lineHeight: '100%',
};
export var medium = {
    fontSize: "".concat(14, "px"),
    minWidth: 32,
    minHeight: 32,
    fontWeight: '625',
    lineHeight: '100%',
    padding: "".concat(4, "px ").concat(16, "px"),
};
export var large = {
    fontSize: "".concat(14),
    minWidth: 40,
    minHeight: 40,
    fontWeight: '625',
    lineHeight: '100%',
    padding: "".concat(8, "px ").concat(24, "px"),
};
export var smallBorderless = __assign({}, small);
export var mediumBorderless = __assign({}, medium);
export var largeBorderless = __assign({}, large);
export var buttonGroupButton = {
    margin: 0,
    borderRadius: 0,
    '&:first-of-type': {
        borderTopLeftRadius: 999,
        borderBottomLeftRadius: 999,
    },
    '&:not(:first-child)': {
        marginLeft: -1,
    },
    '&:last-of-type': {
        borderTopRightRadius: 999,
        borderBottomRightRadius: 999,
    },
};
export var buttonGroup = __assign(__assign({}, reset), (_b = { display: 'inline-block', padding: 0, position: 'relative' }, _b["@media ".concat(mobile(700))] = {
    marginBottom: 16,
}, _b['button, a'] = __assign({}, buttonGroupButton), _b));
export var buttonGroupFullWidth = __assign(__assign({}, buttonGroup), { display: 'flex' });
export var combinators = (_c = {
        '& + &': {
            marginLeft: 'var(--sibling-margin)',
        },
        '&:first-child': {
            marginLeft: 0,
        }
    },
    _c["@media ".concat(mobile(700))] = {
        '&.citrus-button-responsive': {
            '& + &': {
                marginLeft: 0,
                marginTop: 16,
            },
            '&:first-child': {
                marginLeft: 0,
            },
        },
    },
    _c);
export var hiddenText = {
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: '1px',
    overflow: 'hidden',
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px',
};
export var removeSiblingMargin = {
    '& + button, & + a': {
        marginLeft: '0px !important',
    },
    '& + &': {
        marginLeft: '0px !important',
    },
};
export var stackableGroup = {
    display: 'flex',
    flexWrap: 'wrap',
    columnGap: 12,
    rowGap: 12,
};
